import React from 'react';
import moment from 'moment';
import {
  Card,
  Button,
  Input,
  Dropdown,
  DatePicker,
  Row,
  Checkbox,
  Table,
  ExpandableTable
} from 'components';
import { Modal, Form } from 'react-bootstrap';

import { parseHsppId, renderStatusColorClass } from 'services/helpers';
import { Link } from 'react-router-dom';
import ButtonBTN from 'react-bootstrap/Button';
import * as FileServer from 'file-saver';
import * as XLSX from 'xlsx';
import { FaSyncAlt } from 'react-icons/fa';
const Body = ({ _this }) => {
  const searchByLabels = {
    location_name: 'Location Name',
    franchise_name: 'Franchise Name',
    location_group: 'Location Group',
    state: 'State',
    total: 'Total'
  };

  const dynamicColumnKey =
    _this?.activeHsppExistingVsNewPatientDetails?.search_by?.value || 'total';

  const exportReport = () => {
    const extractedDataArray = _this.tableData.map((dataObject) => ({
      [searchByLabels[dynamicColumnKey] || 'Type']: dataObject?.[dynamicColumnKey] || '-',

      'Active HSPP Patients': dataObject?.active_patients || 0,

      'New Patients': dataObject?.new_patients_count || 0,

      'Existing Patients': dataObject?.existing_patients_count || 0
    }));

    const fileType =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';

    const fileExtension = '.xlsx';

    const ws = XLSX.utils.json_to_sheet(extractedDataArray);

    const wb = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(wb, ws, 'Active Hspp Patients');

    const excelBuffer = XLSX.write(wb, {
      bookType: 'xlsx',
      type: 'array'
    });

    const data = new Blob([excelBuffer], {
      type: fileType
    });

    FileServer.saveAs(data, `Active_Hspp_Existing_Vs_New_Report`);
  };

  const columns = [
    {
      name: searchByLabels[dynamicColumnKey] || 'State',

      cell: (row) => row?.[dynamicColumnKey] || '-',

      selector: (row) => row?.[dynamicColumnKey],

      sortable: true
    },

    {
      name: 'Active HSPP Patients',
      cell: (row) => row?.active_patients,
      selector: (row) => row?.active_patients,
      sortable: true
    },

    {
      name: 'New Patients',
      cell: (row) => row?.new_patients_count,
      selector: (row) => row?.new_patients_count,
      sortable: true
    },

    {
      name: 'Existing Patients',
      cell: (row) => row?.existing_patients_count,
      selector: (row) => row?.existing_patients_count,
      sortable: true
    }
  ];
  return (
    <div className="flex flex-col gap-1">
      <Card background={'bg-cardbg1'} className="">
        <div className="relative flex flex-col sm:flex-row gap-2 justify-between items-center">
          <h3 className="text-body-color text-xl md:text-2xl">
            Active Hspp Existing Vs New Patient Report
          </h3>

          <DatePicker
            label="Start Date"
            required
            value={_this.activeHsppExistingVsNewPatientDetails?.start_date || ''}
            onChange={(e) => {
              _this.setActiveHsppExistingVsNewPatientDetails((prev) => ({
                ...prev,
                start_date: e
              }));
            }}
          />

          <DatePicker
            label="Current Date"
            required
            value={_this.activeHsppExistingVsNewPatientDetails?.current_date || ''}
            onChange={(e) => {
              _this.setActiveHsppExistingVsNewPatientDetails((prev) => ({
                ...prev,
                current_date: e
              }));
            }}
          />

          <Dropdown
            label="Search By"
            className="w-48 z-10"
            placeholder="@location"
            required
            type="text"
            options={_this.activeHsppPatientOptions}
            aria-label="Default select example"
            value={_this.activeHsppExistingVsNewPatientDetails.search_by}
            onChange={(e) => {
              _this.setActiveHsppExistingVsNewPatientDetails((prev) => ({
                ...prev,
                search_by: e
              }));
            }}
          />

          <button
            className="bg-button-primary mt-3 hover:bg-button-primaryHover text-white px-2 py-2 rounded text-base flex flex-row self-center w-48 justify-center items-center"
            onClick={_this.init}
          >
            Generate Report
          </button>
        </div>
      </Card>

      <Card className="flex mr-2 mt-2" paddingClass="px-1 py-2">
        <div className="flex justify-between items-center p-2">
          <div className="flex gap-2">
            <ButtonBTN
              onClick={() => exportReport()}
              className={`bg-button-primary  mb-2`}
              variant="primary"
              id="export"
            >
              Export
            </ButtonBTN>
            <ButtonBTN
              onClick={() => _this.syncReport()}
              className={`bg-button-primary mb-2 ml-2 flex justify-between items-center`}
              variant="primary"
              id="export"
              disabled={_this.inSync}
            >
              Sync <FaSyncAlt className={`ml-1 ${_this.inSync ? 'animate-spin' : ''}`} />
            </ButtonBTN>
          </div>
          <input
            type="search"
            placeholder="Search.."
            value={_this.searchInput}
            onChange={(e) => _this.setSearchInput(e.target.value)}
          />
        </div>
        <ExpandableTable
          keyField="_id"
          columnDefs={columns}
          rowData={_this.tableData}
          onRowExpanded={_this.onRowExpanded}
          // headerComponent={null}
          minRows={20}
        />
      </Card>
      {/* {_this.activeHsppExistingVsNewPatientDetails.search_by.value == 'location_name' && (
        <LocationName _this={_this} />
      )}
      {_this.activeHsppExistingVsNewPatientDetails.search_by.value == 'location_group' && (
        <LocationGroup _this={_this} />
      )}
      {_this.activeHsppExistingVsNewPatientDetails.search_by.value == 'franchise_name' && (
        <FranchiseName _this={_this} />
      )}
      {_this.activeHsppExistingVsNewPatientDetails.search_by.value == 'state' && (
        <State _this={_this} />
      )}
      {_this.activeHsppExistingVsNewPatientDetails.search_by.value == 'total' && (
        <Total _this={_this} />
      )} */}
    </div>
  );
};

export default Body;
